import { render } from "./FormOffer.vue?vue&type=template&id=23e4d182"
import script from "./FormOffer.vue?vue&type=script&lang=js"
export * from "./FormOffer.vue?vue&type=script&lang=js"
script.render = render

export default script